import { defineStore } from 'pinia';
import type { INotificacion } from '~~/interfaces';
import { useServiciosStore } from './servicios';
import { BASE_SERVICIO_ID, BASE_SERVICIO_SLUG } from '~~/constants';

export const useNotificacionesStore = defineStore('notificaciones', () => {
  const {
    public: { dbUrl: BASE_URL_DB },
  } = useRuntimeConfig();
  const servicioStore = useServiciosStore();

  const BASE_URL = `${BASE_URL_DB}/notificaciones`;

  const notificaciones = ref<Map<string, INotificacion[]>>(new Map());
  const loading = ref(false);
  const timeoutNotifs = ref<ReturnType<typeof setTimeout>>();
  const notifs = computed(
    () =>
      notificaciones.value
        .get(servicioStore.servicioId || BASE_SERVICIO_ID)
        ?.filter((n) => n.active) || []
  );

  async function getNotificaciones(servicioId: string = BASE_SERVICIO_ID) {
    if (loading.value || servicioStore.servicio !== BASE_SERVICIO_SLUG) return;

    return getNotificacionesApi(servicioId);
  }

  async function getNotificacionesApi(servicioId: string = BASE_SERVICIO_ID) {
    if (loading.value) return;
    loading.value = true;

    const res = await fetch(`${BASE_URL}/_find`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        selector: {
          $and: [
            { active: { $eq: true } },
            { date: { $exists: true } },
            { srv: { $eq: String(servicioId) } },
          ],
        },
        sort: [{ date: 'desc' }],
        limit: 5,
      }),
    })
      .then((d) => d.json())
      .then((d) => d.docs || [])
      .catch(() => [] as INotificacion[])
      .finally(() => (loading.value = false));

    notificaciones.value.set(servicioId, res);
    return res;
  }

  onMounted(() => {
    timeoutNotifs.value = setTimeout(() => getNotificaciones(), 60e3 * 1);
  });

  onUnmounted(() => clearTimeout(timeoutNotifs.value));

  return {
    getNotificaciones,
    notifsMap: notificaciones,
    notificaciones: notifs,
  };
});
